/* eslint-disable react/prop-types */
import './payment-summary-table.scss';

const PaymentSummaryTable = (props) => {
  const { contentInfo, contentType, creditList } = props;
  const formatCurrency = (number) => {
    return (
      new Intl.NumberFormat('es-ES').format(number) +
      (Number.isInteger(parseFloat(number)) ? ',00' : '')
    );
  };

  const handleTotalPrice = () => {
    let priceTotal = 0;
    for (const credit of creditList) {
      priceTotal += +credit.value;
    }
    return priceTotal;
  };

  return (
    <div
      data-testid="summary-table"
      className={`a-summary-table ${creditList.length > 1 ? 'a-summary-table--lot' : ''}`}
    >
      <div className={`a-summary-table__header ${creditList.length > 1 ? 'hide-mobile' : ''}`}>
        <div className="a-summary-table__header__item firts">
          {contentType === 'pension' ? 'Referencia de pago' : contentInfo[0]}
        </div>
        {creditList.length === 1 && (
          <p className="hide-desktop a-summary-table__header__result">{creditList[0].code}</p>
        )}
        <div className="a-summary-table__header__item second">{contentInfo[1]}</div>
        {creditList.length === 1 && (
          <p className="hide-desktop  a-summary-table__header__result">
            {creditList[0].descrption}
          </p>
        )}
        <div className={`three-price ${creditList.length > 1 ? '--multiple' : ''}`}>
          <div
            className={`a-summary-table__header__item ${creditList.length > 1 ? 'three__lot' : ''}`}
          >
            {contentInfo[2]}
          </div>
          {creditList.length === 1 && (
            <p className="hide-desktop  a-summary-table__header__result value-price">
              ${formatCurrency(creditList[0].value)}
            </p>
          )}
        </div>
      </div>
      <div className="a-summary-table__data">
        {creditList.length &&
          creditList.map((ele, index) => (
            <>
              <div
                className="a-summary-table__data__content"
                key={`a-summary-table__data__content${index}`}
              >
                <p className="a-summary-table__data__info firts">{ele.code}</p>
                <p className="a-summary-table__data__info second">{ele.descrption}</p>
                <p
                  className={`a-summary-table__data__info three  ${
                    creditList.length > 1 ? 'three__lot' : 'value-price'
                  }`}
                >
                  ${formatCurrency(ele.value)}
                </p>
              </div>
              {creditList.length > 1 && (
                <div className="content__separate">
                  <span className="content__separate--active" />
                </div>
              )}
            </>
          ))}

        {creditList.length > 1 && (
          <div className="a-summary-table__data__lot">
            <p />
            <p className="a-summary-table__data__lot__title">Valor total</p>
            <p className="three three__lot value-price">
              ${formatCurrency(handleTotalPrice())}
              {/* ${formatCurrency(handleTotalPrice())},00 */}
            </p>
          </div>
        )}
      </div>
      {creditList.length > 1 && (
        <div className="a-summary-table__pensions hide-desktop">
          {creditList.length > 1 &&
            creditList.map((item, index) => (
              <div
                className="a-summary-table__pensions__card"
                key={`a-summary-table__pensions__card${index}`}
              >
                <p className="a-summary-table__pensions__card__title">
                  Crédito {index + 1}
                  {/* Cuota {index + 1} */}
                </p>
                <div className="a-summary-table__pensions__card__body">
                  <p className="a-summary-table__pensions__card__body__name">Formulario</p>
                  <p className="a-summary-table__pensions__card__body__value">{item.code}</p>
                  <div className="content__separate">
                    <span className="content__separate--active total-width" />
                  </div>
                  <p className="a-summary-table__pensions__card__body__name">Descripción</p>
                  <p className="a-summary-table__pensions__card__body__value">{item.descrption}</p>
                  <div className="content__separate">
                    <span className="content__separate--active total-width" />
                  </div>
                  <div className="a-summary-table__pensions__card__footer">
                    <p className="a-summary-table__pensions__card__footer__name">Valor a pagar</p>
                    <p className="a-summary-table__pensions__card__footer__price">
                      ${formatCurrency(item.value)}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          <div className="a-summary-table__pensions__total">
            <p className="a-summary-table__pensions__total__name">Valor total</p>
            <p
              className="value-price a-summary-table__pensions__total__price"
              data-testid="total-price"
            >
              ${formatCurrency(handleTotalPrice())}
            </p>
          </div>
          <div className="content__separate">
            <span className="content__separate--active total-width" />
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentSummaryTable;
